import { render, staticRenderFns } from "./navlist.vue?vue&type=template&id=87c69676&scoped=true&"
import script from "./navlist.vue?vue&type=script&lang=js&"
export * from "./navlist.vue?vue&type=script&lang=js&"
import style0 from "./navlist.vue?vue&type=style&index=0&id=87c69676&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87c69676",
  null
  
)

export default component.exports